import { Component, OnDestroy, OnInit, ViewEncapsulation } from "@angular/core";
import { FormControl } from "@angular/forms";
import { FieldType, FormlyFieldConfig } from "@ngx-formly/core";
import { Subject } from "rxjs";
import { debounceTime, finalize, takeUntil } from "rxjs/operators";
import { Cid10Service, IIcd } from "../cid10.service";

@Component({
    selector: "formly-field-cid10",
    templateUrl: "formly-cid10.component.html",
    encapsulation: ViewEncapsulation.None,
    providers: [Cid10Service],
})
export class FormlyCid10Component extends FieldType implements OnInit, OnDestroy {
    private _unsubscribeAll = new Subject();

    selected: IIcd[] = [];

    datasource$: Subject<IIcd[]> = new Subject();

    loading$ = new Subject<boolean>();

    filterCtrl: FormControl = new FormControl();

    selectCtrl: FormControl = new FormControl();

    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(private _service: Cid10Service) {
        super();
    }

    ngOnInit(): void {
        this.formControl.valueChanges.pipe(takeUntil(this._unsubscribeAll)).subscribe((value) => {
            if (!value) {
                this.selected = [];
            }
        });

        if (this.formControl.value) {
            let currentValue = JSON.parse(this.formControl.value);
            this.selected = currentValue.map((v) => {
                let items = v.split(":");
                return { subCategoryId: items[0], title: items[1] } as IIcd;
            });
        }

        this.filterCtrl.valueChanges.pipe(takeUntil(this._unsubscribeAll), debounceTime(200)).subscribe((keyword) => {
            if (!!keyword) {
                this.loading$.next(true);
                this._service
                    .search(keyword)
                    .pipe(finalize(() => this.loading$.next(false)))
                    .subscribe((result) => {
                        this.datasource$.next(result);
                    });
            } else {
                this.datasource$.next([]);
            }
        });

        this.selectCtrl.valueChanges.pipe(takeUntil(this._unsubscribeAll)).subscribe((value) => {
            let alreadyExists = this.selected.find((element) => element.subCategoryId === value.subCategoryId);
            if (!alreadyExists) {
                this.selected.push(value);
                this.onSelectedChange();
            }
        });
    }

    ngOnDestroy(): void {
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }

    remove(cid) {
        this.selected = this.selected.filter((element) => element !== cid);
        this.onSelectedChange();
    }

    onSelectedChange() {
        this.formControl.setValue(this.selected.map((c) => `${c.subCategoryId}:${c.title}`));
    }

    isDisabled() {
        return this.field.templateOptions.disabled;
    }

    isValid(field: FormlyFieldConfig) {
        if (field.key) {
            return field.formControl.valid;
        }
        return field.fieldGroup ? field.fieldGroup.every((f) => this.isValid(f)) : true;
    }
}
